import React from 'react';
import { css } from '@emotion/react';
import { Text, Space, Icon, colors, IAvailableIcons } from 'common-components';
import { useAppTranslation } from '@hooks';
import { TxKeyPath } from '@i18n/i18n';
import { SegmentTypeType, TSegmentDefType } from '@definitions';

interface PillProps {
  id: TSegmentDefType
  icon: IAvailableIcons
  title: string
  text: string
}

type PillComponentPropsType = {
  elem: PillProps
  segmentType: SegmentTypeType
  setSegmentType: (typeSegment: SegmentTypeType) => void
};

const PillComponent = ({ elem, segmentType, setSegmentType }: PillComponentPropsType) => {
  const { translate } = useAppTranslation();

  return (
    <Space
      key={elem.id}
      onClick={() => {
        setSegmentType(elem.id);
      }}
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        gap: 6px;
        text-align: center;
        cursor: pointer;
        padding: 19px;
        border: 1px solid ${segmentType === elem.id ? colors.gray600 : colors.gray200};
        border-radius: 10px;
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          width: 32px;
          height: 32px;
          background: ${colors.gray100};
          border: 4px solid ${colors.gray50};
          border-radius: 28px;
        `}
      >
        <Icon color={colors.gray600} icon={elem.icon} size={16} />
      </div>
      <Text color={colors.gray700} style={{ fontWeight: 600, display: 'block' }}>
        {translate(`createSegment.${elem.title}` as TxKeyPath)}
      </Text>
      <Text color={'#8F97B3'} size={'xs'} style={{ display: 'block' }}>
        {translate(`createSegment.${elem.text}` as TxKeyPath)}
      </Text>
    </Space>
  );
};

export default PillComponent;
